import styled from 'styled-components'

export const SubmitButtonBlock = styled.div`
  display: block;
  float: ${props => props.float || 'right'};
`



// WEBPACK FOOTER //
// ./src/Components/Form/SubmitButton/SubmitButtonBlock/index.js